import { render, staticRenderFns } from "./ExternalNavItem.vue?vue&type=template&id=5a4729af&scoped=true"
import script from "./ExternalNavItem.vue?vue&type=script&lang=js"
export * from "./ExternalNavItem.vue?vue&type=script&lang=js"
import style0 from "./ExternalNavItem.vue?vue&type=style&index=0&id=5a4729af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4729af",
  null
  
)

export default component.exports